export default __webpack_public_path__ + "static/media/commercial_credit_line.4a94e289.svg";